import { useEffect } from 'react';
import { PARRAINAGE_CHANGED, PARRAINAGE_REVISION_KEY } from '@/lib/parrainageRefresh';

export function useParrainageRefresh(refresh, enabled = true) {
    useEffect(() => {
        if (!enabled) return;
        let timer;
        const queue = () => {
            if (document.visibilityState === 'hidden') return;
            clearTimeout(timer);
            timer = setTimeout(refresh, 150);
        };
        const onStorage = (event) => { if (event.key === PARRAINAGE_REVISION_KEY) queue(); };
        refresh();
        window.addEventListener(PARRAINAGE_CHANGED, queue);
        window.addEventListener('storage', onStorage);
        window.addEventListener('focus', queue);
        window.addEventListener('pageshow', queue);
        document.addEventListener('visibilitychange', queue);
        // Les changements d'un autre utilisateur/appareil sont également repris.
        const interval = setInterval(queue, 30000);
        return () => {
            clearTimeout(timer);
            clearInterval(interval);
            window.removeEventListener(PARRAINAGE_CHANGED, queue);
            window.removeEventListener('storage', onStorage);
            window.removeEventListener('focus', queue);
            window.removeEventListener('pageshow', queue);
            document.removeEventListener('visibilitychange', queue);
        };
    }, [refresh, enabled]);
}